// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isCustomObjectAttrIssue = anyOf(
  objectOf({
    field: string,
    kind: enumOf("required_missing"),
  }),
  objectOf({
    field: string,
    kind: enumOf("type_mismatch"),
    expected_type: string,
    actual_type: string,
  })
);

const isCustomObjectApiItem = objectOf({
  type_name: string,
  external_id: string,
  attributes: objectOf({}),
  attr_issues: arrayOf(isCustomObjectAttrIssue),
});

export const isGetCustomObjectsTypeNameExternalIdResult = objectOf({
  data_objects: arrayOf(isCustomObjectApiItem),
});

export const isPatchCustomObjectsTypeNameExternalIdResult = isGetCustomObjectsTypeNameExternalIdResult;
